import { useState, useEffect } from 'react';
import type { PortalContext } from '../types';

export const usePortalContext = (): PortalContext => {
  const [ctx, setCtx] = useState<PortalContext>({ clientMac: '', apMac: '', ssid: '', redir: 'http://tapete.bar' });

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const dev = process.env.NODE_ENV === 'development';
    setCtx({
      clientMac: p.get('clientMac') || (dev ? 'de:ad:be:ef:00:01' : ''),
      apMac:     p.get('apMac')     || (dev ? '11:22:33:44:55:66' : ''),
      ssid:      p.get('ssid')      || (dev ? 'TapeteNett-Dev'    : ''),
      redir:     p.get('redirectUrl') ?? p.get('redirurl') ?? 'http://tapete.bar',
    });
  }, []);

  return ctx;
}
